<div class="footer" id="footer">
    <div class="upper">
        <div class="links">
            <a href="#" class="arrow" (click)="toggleLower($event)" [ngClass]="{'down': lowerOpen}">
                <div class="svg">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 143 110"><path d="M143 90.34L122.54 110 71.5 45.87 20.46 110 0 90.34 71.5 0 143 90.34z"/></svg>
                </div>
            </a>
            <p>&copy; Bayer</p>

            <div *ngFor="let link of data.links" (click)="linkClick(link)" class="link" [innerHTML]="link.text"></div>
        </div>

        <p class="intent" [innerHTML]="data.intent"></p>
    </div>

    <div class="lower" [ngClass]="{'open': lowerOpen}">
        <div class="inner">
            <p *ngFor="let p of data.copyright" [innerHTML]="p"></p>
        </div>
    </div>
</div>
